var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { CONNECTION_ERROR_MESSAGE } from "../constants";
var useAppAlert = function () {
    var _a = __read(useState(!window.navigator.onLine), 2), alertVisible = _a[0], setAlertVisible = _a[1];
    useEffect(function () {
        setAlertVisible(!window.navigator.onLine);
    }, [window.navigator.onLine]);
    var AlertComponent = function () { return (_jsx("div", { hidden: !alertVisible, children: _jsx("div", { className: "alert-message", "data-color": "yellow", "data-status": "active", children: _jsx("div", { className: "container", children: _jsxs("div", { className: "content", children: [_jsxs("div", { className: "c-center", children: [_jsx("img", { src: "/static/vendors/images/icons/warning-y.svg", alt: "" }), _jsxs("p", { children: [CONNECTION_ERROR_MESSAGE, " "] })] }), _jsx("div", { className: "close", "data-modal": "alert-msg-close", children: _jsx("img", { src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/cross.svg"), alt: "close" }) })] }) }) }) })); };
    return [alertVisible, AlertComponent];
};
export default useAppAlert;
